import React, { useEffect, useRef } from "react";
import { postSessionRefresh } from "../helpers/api/apiCore";

const REFRESH_INTERVAL_MS = 14 * 60 * 1000;

const TokenRefreshHandler: React.FC = () => {
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    const refresh = () => {
      postSessionRefresh().catch(() => {});
    };

    intervalRef.current = setInterval(refresh, REFRESH_INTERVAL_MS);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  return null;
};

export default TokenRefreshHandler;
